/**
 * Type of settlement price
 * tag: 731
 * @readonly
 * @enum {number} (int)
 */
export enum SettlPriceType {
  /** Final */
  Final = 1,
  /** Theoretical */
  Theoretical = 2,
}
